export default {
  actionLoading: (state) => state.actionLoading,
  pollingLoading: (state) => state.pollingLoading,
  loading: (state) => state.loading,
  items: (state) => state.items,
  search: (state) => state.search,
  sort: (state) => state.sort,
  chronologySort: (state) => state.chronologySort,
  page: (state) => state.page,
  total: (state) => state.total,
  statistics: (state) => state.statistics,
  currentInvoice: (state) => state.currentInvoice,

  // Новые геттеры для фильтров
  statusFilter: (state) => state.statusFilter,
  dateFromFilter: (state) => state.dateFromFilter,
  dateToFilter: (state) => state.dateToFilter,
  dateRange: (state) => {
    if (state.dateFromFilter && state.dateToFilter) {
      return [state.dateFromFilter, state.dateToFilter]
    }
    return []
  },
  isOneTimeFilter: (state) => state.isOneTimeFilter,
  isUnfixedAmountFilter: (state) => state.isUnfixedAmountFilter,
}
